import axios from 'axios';
import { AUTH_TOKEN, SESSION_ID, STATE } from '../data/local-storage-constants';
import {
  clearLocalStorage,
  getLocalStorage,
  removeLocalStorage,
} from '../utils';
import { ENDPOINT } from './apiUrls';
import store from '../redux/store';
import {
  clearPollingData,
  logout,
  resetCreditReportData,
  resetLeads,
  resetLendersData,
} from '../redux/slices';
import history from '../history';
import { GST_ROUTE, HOME_PAGE_ROUTE } from '../data/routes-constants';
import { isFlipkartFlow } from '../features/credit-report-apply/helper';

const defaultOptions = {
  headers: {
    'Content-Type': 'application/json',
  },
};

const createApiInstance = (baseUrl: any) => {
  const api = axios.create({
    ...defaultOptions,
    baseURL: baseUrl,
  });

  api.interceptors.request.use((config: any) => {
    const token = getLocalStorage(AUTH_TOKEN);

    const endpointsRequiringAuth = [
      ENDPOINT.CREDIT_REPORT.getCreditScore,
      ENDPOINT.CREDIT_REPORT.getCreditScorePan,
      ENDPOINT.CREDIT_REPORT.authenticateMaskedMobile,
      ENDPOINT.CREDIT_REPORT.consentRevoke,
      ENDPOINT.CREDIT_REPORT.creditDetails,
      ENDPOINT.CREDIT_REPORT.bureauData,
      ENDPOINT.AUTH.logoutUser,
      ENDPOINT.LEADS.gstData,
    ];

    const matchesEndpoint = (url: string) => {
      return endpointsRequiringAuth.some((endpoint) =>
        url.includes(endpoint.replace(/{.*}/, ''))
      );
    };

    if (token && config && matchesEndpoint(config.url)) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    const sessionId = getLocalStorage(SESSION_ID);
    if (sessionId) {
      config.headers['session_id'] = sessionId;
    }

    return config;
  });

  api.interceptors.response.use(
    (response) => {
      return response.data;
    },
    (error) => {
      if (error.response && error.response.status === 401) {
        isFlipkartFlow()
          ? history.push(GST_ROUTE)
          : history.push(HOME_PAGE_ROUTE);
        removeLocalStorage(AUTH_TOKEN);
        removeLocalStorage(STATE);
        clearLocalStorage();
        store.dispatch(logout());
        store.dispatch(resetCreditReportData());
        store.dispatch(resetLeads());
        store.dispatch(resetLendersData());
        store.dispatch(clearPollingData());
      }
      return Promise.reject(error);
    }
  );

  return api;
};

export default createApiInstance;
